export const colors = {
  white: '#ffffff',
  gray: {
    300: '#f8f9f9',
    400: '#f2f2f4',
    700: '#b0b2bc',
    800: '#92939c',
    900: '#62636b',
  },
  black: '#282e38',
  blue: '#2980ff',
}

export const fontWeight = {
  normal: 400,
  bold: 700,
  black: 900,
}

export const mobileWidth = '600px'
export const maxWidth = '1200px'
export const desktopMargin = '40px'
export const mobileMargin = '20px'
